module.exports = __webpack_public_path__ + "01_mole.73c26340.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer2/01_mole.png
// module id = wlno
// module chunks = 0